<div class="ya-bottomsheet-container ya-typography">
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>
    <h2 langkey="phDiscardBasketDialog_Title"></h2>
    <div>
      <p langkey="phDiscardBasketDialog_Content"></p>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <ng-container *ngIf="allowBasketModification">
              <button class="ghostbutton" (click)="clearBasketItems()">
                <span langkey="phDiscardBasketDialog_ResetBasket_Button"></span>
              </button>
            </ng-container>
          </div>

          <div class="ya-button-container">
            <button mat-flat-button (click)="backtoBasket()">
              <span langkey="phDiscardBasketDialog_RemainOrder_Button"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>